import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Select, Input, Pagination, Result, message } from 'antd';
// import { AiOutlineSearch } from 'react-icons/ai';
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from 'react-icons/fa';
import CampaignCardComponent from '../../components/Influencers/Campaign/CampaignCardComponent';
// import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent'
// import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent'
import { CampaignList } from '../../apis/Influencer/Campaigns/CampaignList';
import { useGlobalState } from '../../store/state';
import { CampaignDelete } from '../../apis/Brand/Campaigns/CampaignDelete';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import PlatformIconRender from '../../components/Common/PlatformIconRender';

const InfluencerCampaignPage = (props) => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [campList, setCampList] = useState({
    campaigns: [],
  });
  const [baseConfig, setBaseConfig] = useState({
    type: 'all',
    page: 1,
  });
  const getCampiagnList = (type, page) =>{
    CampaignList(
      user.accessToken,
      { type: type, page: page },
    ).then(({ status, response })=>{
      console.log('retrived Data in influ', response);
      if (status === 200) {
        setCampList({
          ...campList,
          ...response,
        });
      } else {
        message.error('There is some error in getting Campaign list');
      }
    });
  };
  useEffect(() =>{ // load all list first time
    // console.log("props",params)
    getCampiagnList();
    // console.log("campList",campList)
  }, []);
  const renderPlatform = (platform)=>{ // render platform icons
    switch (platform) {
    case 'youtube': return <FaYoutube/>;
    case 'instagram': return <FaInstagram color="#dd2a7b"/>;
    case 'twitter': return <FaTwitter/>;
    default: return null;
    }
  };
  const changeCampaignType = (v) =>{ // chaning camp type
    setBaseConfig({
      ...baseConfig,
      type: v,
      page: 1,
    });
    getCampiagnList(v, 1);
  };
  const onPagingChange = (page)=>{ // pager changing
    getCampiagnList(baseConfig.type, page);
    setBaseConfig({
      ...baseConfig,
      page: page,
    });
  };

  const deleteDraft = (campId) =>{
    // console.log("camp",campId)
    // console.log("pars",params.companyId)
    CampaignDelete(user.accessToken, {
      campaignid: campId,
      brand: params.companyId,
    }).then(({ response, status }) =>{
      console.log('res', response);
      if (status === 200) {
        getCampiagnList();
      }
    });
  };
  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-4">
            <p className="m-0"><strong>Campaigns</strong></p>
          </div>
          <div className="col-md-8">
            <div className="row justify-content-end">
              <div className="col-md-4">
                <div className="common_select">
                  <Select defaultValue={baseConfig.type}
                    size="large"
                    onChange={changeCampaignType}>
                    <Select.Option value="all">All</Select.Option>
                    <Select.Option value="assigned">Assigned</Select.Option>
                    <Select.Option value="accepted">Accepted</Select.Option>
                    <Select.Option value="review">In Review</Select.Option>
                    {/* <Select.Option value="deleted">Deleted</Select.Option> */}
                    <Select.Option value="active">Active</Select.Option>
                    <Select.Option value="approved">Approved</Select.Option>
                    <Select.Option value="closed">Closed</Select.Option>
                    {/* <Select.Option value="completed">Completed</Select.Option> */}
                    <Select.Option value="self_reject">Self Reject</Select.Option>
                    <Select.Option value="admin_reject">Admin Reject</Select.Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </InfluencerTopSubHeaderComponent>
      <div style={{ padding: 10 }}>
        <div className="campaign_cards">
          <div className="d-flex flex-wrap">
            {campList.campaigns.length ?
              (campList.campaigns.map((camp)=>(
                <CampaignCardComponent
                  key={camp._id}
                  status={camp.connectionStatus || 'status'}
                  timeLeft={camp.startdate? moment(camp.startdate).fromNow(): 'N/A'}
                  createdOn={camp.createdAt}
                  title={camp.campaignInfo.name || 'N/A'}
                  campaignid={camp.campaignId}
                  deleteCampaign={deleteDraft}
                  socialIcons={<>
                    {/* <span>
                                            {renderPlatform(camp.campaignInfo.platform)}
                                        </span> */}
                    {/* <span> */}
                    <PlatformIconRender platform={camp.campaignInfo.platform}
                      size={30}/>
                    {/* {renderPlatform(camp.campaignInfo.platform)} */}
                    {/* </span> */}
                  </>}
                  taskCount={`Total of ${camp.campaignInfo.posts} creatives`}
                  submissions={camp.submissions || []}
                  brand={camp.brandInfo.companyname}
                  rowData={camp}
                  earningData={camp.campaignInfo.earnings}
                />
              ))) :
              (
                <div className="w-100">
                  <Result
                    title={baseConfig.type==='all'? `No campaign available!`: `No campaign available in ${baseConfig.type} status! `}
                  />
                </div>
              )
            }

          </div>
        </div>
        {
          campList.campaigns.length?
            (<Pagination
              onChange={onPagingChange}
              current={baseConfig.page}
              total={campList.campaignsCount}
              defaultPageSize={campList.limit}
            />) :
            null
        }
      </div>
    </InfluencerBaseLayoutComponent>
  );
};

export default InfluencerCampaignPage;
